import { render, staticRenderFns } from "./principalPage.vue?vue&type=template&id=c517afb4&scoped=true&"
import script from "./principalPage.vue?vue&type=script&lang=js&"
export * from "./principalPage.vue?vue&type=script&lang=js&"
import style0 from "./principalPage.vue?vue&type=style&index=0&id=c517afb4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c517afb4",
  null
  
)

export default component.exports